import React,{useEffect,useRef} from "react";
import { useStoreGlobal } from "../../../stores/Global";
import { useShallow } from "zustand/react/shallow";
export default function PruebasBoton() {
const _totalBotonClic= useStoreGlobal(useShallow((state) => state._totalBotonClic));
let botonConsulta = 0;
let texto=document.getElementById('inputQ') ? document.getElementById('inputQ').value : "";
if(Object.keys(_totalBotonClic).length > 0){
    console.log(_totalBotonClic);
    botonConsulta =_totalBotonClic.botonConsulta;
}

  return(
    <div className="row">
      {
        botonConsulta === 1 ? (
          <div className="col-xs-12">
            <p>Texto de búsqueda: {texto}</p>
          </div>
        ) : (
          ""
        )
      }
      
    </div>
  );
}
